import { PropsWithChildren } from "react";

import { AnalyticsContext } from "@atlaskit/analytics-next";

type ProductName = {
    readonly productName: string;
};

export const SignupAnalyticsContext = ({
    children,
    productName
}: PropsWithChildren<ProductName>) => {
    const defaultAnalyticsData = {
        schemaVersion: 1,
        action: "event",
        event: "event", // event verb, in past tense (eg, "clicked")
        eventType: "ui",
        eventComponent: "signUp", // name of component being interacted with, in camelCase
        eventContainer: "signUp", // container, in camelCase; eg, component that contains this component within a page
        eventColumn: "signUpForm", // should be bundleInformation or signUpForm
        eventName: "signupFormJSWv2",
        uuid: "signupFormJSWv2", // required for Magnolia events, unique id for a given component if available
        productName
    };

    return (
        <AnalyticsContext data={defaultAnalyticsData}>
            {children}
        </AnalyticsContext>
    );
};
